export default __webpack_public_path__ + "static/media/nx-search.365c60bc.svg";